import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPaymentSchedule, IPaymentScheduleState } from 'entities/insurance-contract/payment-shedule/types/PaymentShedule-interface';
import { fetchPaymentSchedule } from 'entities/insurance-contract/payment-shedule/actions/fetch-payment-schedule';


const initialState: IPaymentScheduleState = {
    paymentSchedule: [],
    isLoadingPaymentSchedule: false,
    errorPaymentSchedule: [],
    lastFetchTime: null,
    idCase: null,
};

export const paymentShedule = createSlice({
    name: 'paymentShedule',
    initialState,
    reducers: {
        resetPaymentSheduleData: (state) => {
            state.paymentSchedule = [];
            state.isLoadingPaymentSchedule = false;
            state.errorPaymentSchedule = [];
            state.lastFetchTime = null;
            state.idCase = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPaymentSchedule.pending, (state) => {
                state.isLoadingPaymentSchedule = true;
            })
            .addCase(fetchPaymentSchedule.fulfilled, (state, action: PayloadAction<{ paymentSchedule: IPaymentSchedule[], idCase: string, fetchTime: number }>) => {
                state.isLoadingPaymentSchedule = false;
                state.paymentSchedule = action.payload.paymentSchedule;
                state.errorPaymentSchedule = [];
                state.lastFetchTime = action.payload.fetchTime;
                state.idCase = action.payload.idCase;
            })
            .addCase(fetchPaymentSchedule.rejected, (state, action) => {
                state.paymentSchedule = [];
                state.isLoadingPaymentSchedule = false;
                state.errorPaymentSchedule = action.payload as string[];
            });
    },
});

export const { resetPaymentSheduleData } = paymentShedule.actions;

export default paymentShedule.reducer;